import "./num-pager.css";
